<ng-container [ngSwitch]="captureStyle" *ngIf="isOneIdEnabled">
    <ng-container *ngSwitchCase="EmailCaptureStyle.MODAL">
        <finder-button
            [linkId]="data.linkId"
            [href]="data.urlToLogin"
            [theme]="data.buttonTheme"
            (click)="signUp($event)"
        >{{data.buttonLabel}}</finder-button>
    </ng-container>
    <ng-container *ngSwitchCase="EmailCaptureStyle.INLINE">
        <div class="email-signup">
            <div class="email-input">
                <finder-focus-input *ngIf="!guest"
                    (keyup.enter)="signUp($event)"
                    [value]="'guest?.profile.email'"
                    (focused)="onFocused($event)"
                    [label]="label"
                    [class.error]="email.value && email.invalid && (email.dirty || email.touched)"
                >
                </finder-focus-input>
                <div *ngIf="guest"
                    class="email-value"
                >{{guest.profile.email}}</div>
                <finder-button
                    [linkId]="data.linkId"
                    [href]="data.urlToLogin"
                    [theme]="data.buttonTheme"
                    [disabled]="email.invalid"
                    (click)="signUp($event)"
                >{{data.buttonLabel}}</finder-button>
            </div>
            <p *ngIf="errorMessage"
                @emailErrorMessageAnimation
                tabindex="0"
                class="email-error-message"
            >
                <finder-font-icon size="xs" name="alert"></finder-font-icon>
                {{errorMessage}}
            </p>
            <div *ngIf="isEmailFocused"
                @fadeInOutAnimation
                class="email-terms"
                (focusout)="onTermsFocusOut($event)"
            >
                <p [innerHTML]="legalMessage"></p>
            </div>
        </div>
    </ng-container>
</ng-container>
